import { StationsState } from '../../types';

export const resetStationsPriceReport = (
  state: StationsState
) => ({
  ...state,
  stationsPriceReport: {}
});
